import type { EpdErrorPageLrProps } from '@hotstar/web-ui-components-lib/legacy/components/Template/EpdErrorLr/src';
import dynamic from 'next/dynamic';
import {
  EPD_ERROR_PAGE_STATIC_PROPS,
  EPD_ERROR_PAGE_UN_SERIALIZABLE_PROPS
} from './epd-error/props';
import type { ImportTemplate, StaticPageProp, UnSerializablePageProp } from './models';
import { StaticSitePath } from './models';

export const importEpdErrorTemplateLr = () =>
  dynamic<EpdErrorPageLrProps>(() =>
    import('@hotstar/web-ui-components-lib/legacy/components/Template/EpdErrorLr/src').then(
      (mod) => mod.EpdErrorTemplateLr
    )
  );

export const STATIC_SITE_PROP_MAP: Record<StaticSitePath, StaticPageProp> = {
  [StaticSitePath.EPD_ERROR]: EPD_ERROR_PAGE_STATIC_PROPS
};

export const UN_SERIALIZABLE_PROP_MAP: Record<StaticSitePath, UnSerializablePageProp> = {
  [StaticSitePath.EPD_ERROR]: EPD_ERROR_PAGE_UN_SERIALIZABLE_PROPS
};

export const TEMPLATE_IMPORT_MAP: Record<StaticSitePath, ImportTemplate> = {
  [StaticSitePath.EPD_ERROR]: importEpdErrorTemplateLr
};
